export default "<div class=\"home\">\r\n\r\n</div>"